import { convertObjectToSingleString } from '../../../../../utils/helper';
import { TABLE_BASE_STYLES } from '../../../utils/editorStyles.constants';
export const getTableNode = options => {
  return {
    attrs: {
      alignment: {
        default: ''
      }
    },
    content: 'table_row+',
    tableRole: 'table',
    isolating: true,
    group: options.tableGroup,
    parseDOM: [{
      tag: 'table'
    }],
    toDOM(node) {
      const {
        alignment
      } = node.attrs;
      let tableAttrs = {};
      let tableStyles = '';
      const {
        hasInlineStyles
      } = options;
      if (hasInlineStyles) {
        tableStyles = convertObjectToSingleString(TABLE_BASE_STYLES.table);
        tableAttrs.border = 1;
      }
      if (alignment) {
        tableStyles += convertObjectToSingleString(TABLE_BASE_STYLES[alignment]);
      }
      if (tableStyles) {
        tableAttrs.style = tableStyles;
      }
      return ['table', tableAttrs, ['tbody', 0]];
    }
  };
};